import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	modalConfig: {
		props: {},
		visible: false,
		id: null,
		type: '',
		contentType: '',
		data: {},
		onClick: () => {},
		onClose: null,
		refetch: () => {},
	},
	isLoading: false,
};

const commonStore = (set: any) => ({
	...initialState,
	setModalConfig: (data: any) =>
		set((state: any) => ({
			modalConfig: {
				...state.modalConfig,
				...data,
			},
		})),
	hideCommonModal: () =>
		set({
			modalConfig: initialState.modalConfig,
		}),
	setIsLoading: (data: any) => set((state: any) => ({ ...state, isLoading: data })),
	resetState: () => set({ ...initialState }),
});

const useCommonStore = create(devtools(commonStore));

export const { setModalConfig, setIsLoading, resetState } = useCommonStore.getState();

export default useCommonStore;
